import { PRIMARY_PHONE_NUMBER_FORMATTED } from './global.constants';

export const CUSTOMER_ID_FORM = {
  TITLE: 'Login details',
  SUBTITLE: 'Sign in with your registered Customer ID.',
  FALLBACK_LOGIN_ERROR_MESSAGE: 'Try again later',
  HINT_MESSAGE:
    'You can find your Customer Number (ID) on your Exetel invoice or on an email we have sent you in the past.',
  CALL_US_BUTTON: `Call us on ${PRIMARY_PHONE_NUMBER_FORMATTED}`,
  SUBMIT_BUTTON: 'Login',
};

export const POSTCODE_FORM = {
  TITLE: 'Login details',
  SUBTITLE: 'Sign in with your registered postcode.',
  SUBMIT_BUTTON: 'Login',
};

export const VERIFY_ACCOUNT_FORM = {
  TITLE: 'Verify your account',
  SUBTITLE:
    'We will need to send you a one-time verification code via SMS or email. Multi-Factor Authentication (MFA) helps to strengthen the security of your account.Choose how you would like to receive your verification code.',
  SMS_VERIFICATION_MESSAGE: 'Send a SMS to your phone number',
  FALLBACK_ERROR_MESSAGE:
    'There was an error sending the OTP, please try again.',
  EMAIL_VERIFICATION_MESSAGE: (maskedEmail: string) =>
    `Send an email to - ${maskedEmail}`,
  SUBMIT_BUTTON: 'Send Code',
};

export const CONFIRM_OTP_FORM = {
  TITLE: 'Verify your account',
  FALLBACK_CONFIRM_ERROR_MESSAGE: 'The code is invalid or expired.',
  SUBMIT_BUTTON: 'Verify',
  RESEND_CODE_BUTTON: 'Resend Code',
  BACK_BUTTON: 'Verify another way',
};

export const WELCOME_USER = {
  TITLE: (firstName: string) => `Welcome back, ${firstName}!`,
  SUBTITLE: 'You’ve logged in successfully.',
  PRIMARY_BUTTON: 'Continue',
  SECONDARY_BUTTON: 'Logout',
};
